import {EnvService} from './env.service';

export const EnvServiceFactory = () => {
  const env = new EnvService();

  const envKey = '__env';
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow[envKey] || {};

  for (const key in browserWindowEnv) {
    // eslint-disable-next-line no-prototype-builtins
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[key] = window[envKey][key];
    }
  }

  return env;
};

export const EnvServiceProvider = {
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};
